import HqryInput from '@/components/base/InputHqry.vue'
import MselectOptions from '@/components/base/ElSelectOptions.vue'
import FormItem from '@/components/base/FormItem.vue'
import TableColumn from '@/components/base/TableColumn.vue'

function plugins (Vue) {
  Vue.component('HqryInput', HqryInput)
  Vue.component('MselectOptions', MselectOptions)
  Vue.component('FormItem', FormItem)
  Vue.component('TableColumn', TableColumn)
}

export default plugins
